<template>
<!-- 
  Author: lan.h
  Date: 2021-10-29
  content: 价值领域
-->
  <div class="vb100">
    <div class="p_head">
      <div class="p_title">
        <p>VB100-FHC SUB-LISTS</p>
        <h1>价值领域榜</h1>
      </div>
      <div class="p_links">
        <div class="links-item js-lower-anchor" @click="toA('#list-info')">
          <p class="links-index">01</p>
          <p class="links-name">价值领域榜介绍</p>
          <i class="el-icon-bottom"></i>
        </div>
        <div class="links-item js-lower-anchor" @click="toA('#list-table')">
          <p class="links-index">02</p>
          <p class="links-name">历届价值领域榜</p>
          <i class="el-icon-bottom"></i>
        </div>
      </div>
    </div>
    <div class="p_image">
      <div class="p_image_inner">
        <img src="~/img/main/jia.png">
      </div>
    </div>
    <div class="list-content" id="list-info">
      <!-- 榜单介绍 -->
      <div class="info">
        <div class="list-title">价值领域榜介绍</div>
        <div class="list-desc">{{introduce}}</div>
      </div>
    </div>
    <!-- 历届榜单 -->
    <div class="his-content" id="list-table">
      <div class="list-content">
        <div class="info">
          <div class="list-title">历届价值领域榜</div>
          <div class="list-png">
            <img src="~/img/main/list.png" />
          </div>
        </div>
        <div class="table-title">
          <div class="award-title">
            <img class="title-left" src="~/img/main/left.png" />
            <div class="list-name">
              <div class="year">{{time_index.year}}</div>
              <div class="name">{{time_index.name}}</div>
            </div>
            <img class="title-left" src="~/img/main/right.png" />
          </div>
        </div>
        <!-- 表格 -->
        <div class="list-wap">
          <div class="list-table" ref="table">
            <el-table v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData" :header-cell-style="{background:'#2A2F42', color: '#E9E9EB'}" :key="key_index">
              <template v-for="item,index in columns">
                <!-- 实体 -->
                <el-table-column align="center" v-if="item.type == 3" :prop="'col' + index" :label="item.name">
                  <template slot-scope="scope">
                    <div class="table-td">
                      <!-- 动脉橙 -->
                      <p v-if="detail.jump != '0'" class="over-p2">
                        <el-tooltip v-if="getResult(scope.row, detail.jump).description" class="item" effect="dark" :content="getResult(scope.row, detail.jump).description" placement="top">
                          <a v-if="getResult(scope.row, detail.jump).url" class="main_page" :href="getResult(scope.row, detail.jump).url" target="_blank">
                            <span>{{scope.row['col'+index]}}</span>
                          </a>
                          <span v-else>{{scope.row['col'+index]}}</span>
                        </el-tooltip>
                        <span v-else>
                          <a v-if="getResult(scope.row, detail.jump).url" class="main_page" :href="getResult(scope.row, detail.jump).url" target="_blank">
                            <span>{{scope.row['col'+index]}}</span>
                          </a>
                          <span v-else>{{scope.row['col'+index]}}</span>
                        </span>
                      </p>
                      <!-- 官网 -->
                      <!-- <p v-else-if="detail.jump == '2'" class="over-p2">
                        <a v-if="getResult(scope.row, '2')" class="main_page" :href="getResult(scope.row, '2')" target="_blank">{{scope.row['col'+index]}}</a>
                        <span v-else>{{scope.row['col'+index]}}</span>
                      </p> -->
                      <!-- 不跳转 -->
                      <p v-else class="over-p2">
                        <el-tooltip v-if="getResult(scope.row, detail.jump).description" class="item" effect="dark" :content="getResult(scope.row, detail.jump).description" placement="top">
                          <span>{{scope.row['col'+index]}}</span>
                        </el-tooltip>
                        <span v-else>{{scope.row['col'+index]}}</span>
                      </p>
                    </div>
                  </template>
                </el-table-column>
                <!-- 排序 -->
                <el-table-column align="center" v-else-if="item.type == 1" :prop="'col' + index" :label="item.name" sortable>
                  <template slot-scope="scope">
                    <div class="table-td">
                      <p class="over-p2">{{scope.row['col'+index]}}</p>
                    </div>
                  </template>
                </el-table-column>
                <!-- 筛选 -->
                <el-table-column align="center" v-else-if="item.type == 2" :prop="'col' + index" :label="item.name" :filters="item.temp_arr" :filter-multiple="false" :filter-method="filterHandler">
                  <template slot-scope="scope">
                    <div class="table-td">
                      <p class="over-p2">{{scope.row['col'+index]}}</p>
                    </div>
                  </template>
                </el-table-column>
                <!-- 普通字段 -->
                <el-table-column align="center" v-else :prop="'col' + index" :label="item.name">
                  <template slot-scope="scope">
                    <div class="table-td">
                      <p class="over-p2">{{scope.row['col'+index]}}</p>
                    </div>
                  </template>
                </el-table-column>
              </template>
            </el-table>
            <div class="remark" v-html="detail.remarks"></div>
          </div>
          <!-- 锚点 -->
          <div class="anchor-wap">
            <ul class="anchor">
              <li class="anchor-item" v-for="item, index in anchor_list" :key="item.id" @click="openYear(item, index)">
                <div class="anchor-item-title">
                  <div>
                    <span>{{item.name}}</span>
                    <span class="baoming" v-if="item.type == '2'">报名中</span>
                  </div>
                  <!-- 报名中 -->
                  <!-- <i v-if="!item.is_open && item.type == '2'" class="el-icon-right"></i> -->
                  <!-- 加号 -->
                  <i v-if="!item.is_open" class="el-icon-plus"></i>
                  <!-- 减号 -->
                  <i v-if="item.is_open" class="el-icon-minus"></i>
                </div>
                <div class="radio" v-if="item.is_open">
                  <el-radio-group v-model="top_list_id" @change="changeType($event, item)">
                    <el-radio :label="val.id" v-for="val in item.topList" :key="val.id">{{val.title}}</el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="anchor-bottom"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAwardsYearList, getVbTopListById } from '@/service/main.js'
import { list_mixin, scroll_mixin } from 'js/list_mixins'
export default{
  mixins: [list_mixin, scroll_mixin],
  data() {
    return {
      tableData: [],
      columns: [],
      loading: false,
      anchor_list: [],
      top_list_id: '',
      time_index: {},
      detail: '',
      key_index: ''
    }
  },
  computed: {
    list_meta() {
      return this.$store.state.list_meta
    },
    awards_id() {
      let id = this.$store.state.list_meta.awards_meta.find(item => item.route == this.$route.name).id
      return id
    },
    introduce() {
      let introduce = this.$store.state.list_meta.awards_meta.find(item => item.route == this.$route.name).introduce
      return introduce
    }
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      window.onscroll = () => {
        _this.listenerScroll('anchor', 20)
      }
      window.onresize = () => {
        _this.listenerScroll('anchor', 20)
      }
    })
  },
  beforeDestroy(){
    window.onscroll = null
    window.onresize = null
  },
  created() {
    this.imgLoad()
    this.getAwardsYearList()
  },
  methods: {
    imgLoad() {
      !function(){
        var imgNeed = [require('../../assets/img/main/jia.png')],
            len = imgNeed.length,
            i = 0;
 
          function loadImg(i){
              var img = new Image();
              img.src = imgNeed[i];
              img.onload = function(){
                  if(i++<len-1){
                      loadImg(i)
                  }else{
                    $('.p_image').addClass('p_image_ani')
                  }
              }
          }
          loadImg(i);
      }()
    },
    // 锚点跳转
    toA(id) {
      $("html,body").animate({ scrollTop: $(id).offset().top - 80 }, 500);
    },
    //获取年数据
    async getAwardsYearList() {
      let res = await getAwardsYearList({
        awards_id: this.awards_id
      }, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        let num = 0
        let arr = res.res.filter(item => item.topList.length > 0)
        arr.forEach(item =>{
          if(num < 1 && item.type == '1'){
            item.is_open = true
            num++
          }else{
            item.is_open = false
          }
        })
        this.$set(this.$data, 'anchor_list', arr)
        let temp = this.anchor_list.find(item => item.type == '1')
        let top_list_id = temp.topList[0].id
        this.top_list_id = top_list_id
        this.time_index = {
          name: temp.topList[0].title,
          year: temp.name
        }
        this.getVbTopListById(top_list_id)
      } else {
        this.$Message.error(res.msg)
      }
    },
    //获取表格数据
    async getVbTopListById(top_list_id) {
      this.loading = true
      let res = await getVbTopListById({
        top_list_id: top_list_id
      }, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        let deal_temp = this.dealList(res.res.content)
        this.key_index = top_list_id
        this.$set(this.$data, 'tableData', deal_temp.arr)
        this.$set(this.$data, 'columns', deal_temp.col_list)
        this.$set(this.$data, 'detail', res.res)
        this.matching_results = res.res.matching_results ? JSON.parse(res.res.matching_results) : []
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    //单选按钮
    changeType(val, item) {
      if(item.type == '2'){ //报名中
        let temp = item.topList.find(i => i.id == val)
        temp.url ? window.open(temp.url, '_blank') : ''
      }else{
        this.time_index.name = item.topList.find(item => item.id == val).title
        this.time_index.year = item.name
        $("html,body").animate({ scrollTop: $('#list-table').offset().top - 80 }, 500)
        this.getVbTopListById(val)
      }
      
    },
    //展开年
    openYear(item, index) {
      // if(!item.is_open && item.type == '2'){ //报名中
      //   item.url ? window.open(item.url, '_blank') : ''
      // }
      // else{
        this.anchor_list.forEach(item =>{
          item.is_open = false
        })
        let temp = this.anchor_list[index]
        temp.is_open = true
        this.$set(this.$data.anchor_list, index, temp)
      // }
    },
    //表格筛选
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/main/list.stylus';
.his-content
  .table-title
    .award-title
      .title-left
        margin-right 10px
        margin-top 35px
        width 71px
        height 14px
      .title-right
        margin-left 10px
        margin-top 35px
        width 71px
        height 14px
      .list-name
        text-align center
        color #D9BB9E
        .name
          margin-top -20px
          color #D9BB9E
          font-weight bold
          font-size 26px
          line-height 1
        .year
          font-size 56px
          line-height 1
          font-family Arial
          font-weight 900
          color #D9BB9E
          opacity 0.1
          z-index -1
.list-table
  min-height 400px
</style>